import React, { useState } from "react";
import axios from "axios";
import Footer from "../components/Footer.jsx";
import { motion } from "framer-motion";
import logo from "../assets/images/logo-login.png";
import loginCar from "../assets/images/login-car.png";
import passIcon from "../assets/images/passIcon.png";
import phoneIcon from "../assets/images/phone-icon.png";
import eyeIcon from "../assets/images/eye.png";        // ⬅️ NEW
import eyeOffIcon from "../assets/images/eye-off.png"; // ⬅️ NEW
import { API_BASE_URL } from "../utils/api";
import "../styles/LoginPage.css";
import "../styles/mobile-LoginPage.css";
import { initNotifications } from "../firebaseConfigNotification"; // ← من ملف التنبيهات فقط

import MobileFooterSheet from "../components/MobileFooterSheet.jsx";

const VAPID_KEY =
  "BKlu2F5HfRL73j85gRO-PlrDPjpJC9AhS8HPDSC7F_8CotqL2p2C9ek2gcBmC2Uc80wKe5W0nPYXoNkqvcqjsxwBNoUrZTFXTVHGKak0b2xryw-DhxQ6dam1zWxy3trSDg7FJep_B8SjAJcX6_U3OZRUaCTlOjA09_dl1aPWDRKExI";

export default function LoginPage({ onBack, setCurrentView, onLoggedIn }) {
  // === Helpers (KSA only) ===
  const normalizeKsaNational = (raw) => {
    let d = String(raw || "").replace(/\D/g, "");
    if (d.startsWith("966")) d = d.slice(3);
    if (d.startsWith("0")) d = d.slice(1);
    return d;
  };
  const isValidKsaNational = (n) => /^5\d{8}$/.test(n);
  const toE164 = (n) => `+966${n}`;
  const cap9 = (s) => s.slice(0, 9);

  // === Login form state
  const [phoneLocal, setPhoneLocal] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false); // ⬅️ NEW
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  // === Forgot password modal state
  const [isForgotOpen, setIsForgotOpen] = useState(false);
  const [forgotPhoneLocal, setForgotPhoneLocal] = useState("");
  const [sendingOtp, setSendingOtp] = useState(false);
  const [forgotError, setForgotError] = useState("");

  const handleLoginPhoneChange = (val) => {
    const n = cap9(normalizeKsaNational(val));
    setPhoneLocal(n);
  };
  const handleForgotPhoneChange = (val) => {
    const n = cap9(normalizeKsaNational(val));
    setForgotPhoneLocal(n);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setError("");

    const national = normalizeKsaNational(phoneLocal);
    if (!isValidKsaNational(national)) {
      setError("رقم الجوال غير صحيح. أدخل رقم سعودي يبدأ بـ 5 ويتكون من 9 أرقام.");
      setSubmitting(false);
      return;
    }

    const phoneE164 = toE164(national);

    try {
      // جرّب تجيب FCM token بهدوء (ما يوقف الدخول لو فشل)
      let fcmToken = undefined;
      try {
        if (typeof window !== "undefined") {
          const result = await initNotifications(VAPID_KEY);
          if (result?.supported && result?.token) {
            fcmToken = result.token;
          }
        }
      } catch (e) {
        console.warn("Skipping FCM token (unsupported or blocked):", e);
      }

      const response = await axios.post(`${API_BASE_URL}/login`, {
        phone: phoneE164,
        password,
        // لا ترسل null للسيرفر؛ إمّا التوكن أو undefined
        fcm_token: fcmToken || undefined,
      });

      const { token, user } = response.data;
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));

      onLoggedIn?.(user);
      setCurrentView ? setCurrentView("home") : onBack?.();
    } catch (err) {
      console.error("Login error:", err);
      setError(
        err.response?.data?.message ||
        "فشل تسجيل الدخول. تأكد من رقم الهاتف وكلمة السر."
      );
    } finally {
      setSubmitting(false);
    }
  }


  const openForgot = () => {
    setForgotPhoneLocal("");
    setForgotError("");
    setIsForgotOpen(true);
  };

  const sendOtp = async () => {
    if (sendingOtp) return;

    const national = normalizeKsaNational(forgotPhoneLocal);
    if (!isValidKsaNational(national)) {
      setForgotError("أدخل رقم جوال سعودي صحيح (يبدأ بـ 5 ويتكون من 9 أرقام).");
      return;
    }

    const phoneE164 = `+966${national}`;

    try {
      setSendingOtp(true);
      setForgotError("");
      const res = await axios.post(`${API_BASE_URL}/request`, { phone: phoneE164 });

      if (res?.data?.status === true) {
        localStorage.setItem("pending_verification_phone", phoneE164);
        localStorage.setItem("resetPhone", phoneE164); // optional legacy
        setIsForgotOpen(false);
        setCurrentView && setCurrentView("forget");
      } else {
        setForgotError(res?.data?.message || "تعذر إرسال الرمز. حاول مرة أخرى.");
      }
    } catch (e) {
      console.error("send-otp failed:", e);
      setForgotError(e.response?.data?.message || "حدث خطأ أثناء الإرسال. حاول مجدداً.");
    } finally {
      setSendingOtp(false);
    }
  };

  return (
    <div dir="rtl" className="page">
      <div className="clip-bg" aria-hidden="true" />

      {/* Back */}
      <motion.button
        className="back-pill"
        onClick={onBack}
        whileHover={{ scale: 1.03 }}
        whileTap={{ scale: 0.98 }}
        type="button"
      >
        <span>ارجع للخلف</span>
      </motion.button>

      <div className="shell">
        {/* Right: hero */}
        <section className="heroPane">
          <div className="brand">
            <img src={logo} alt="PARTECH" className="brand-logo" />
          </div>
          <div className="carWrap" aria-hidden>
            <img src={loginCar} alt="Sports car" />
          </div>
        </section>

        {/* Left: form */}
        <section className="formPane">
          <header className="formHeader">
            <h1>تسجيل الدخول</h1>
            <p>حياك الله</p>
          </header>

          <form onSubmit={handleLogin} className="form">
            {/* PHONE with +966 prefix */}
            <label className="field field--phone">
              <span className="icon" aria-hidden>
                <img src={phoneIcon} alt="" />
              </span>

              <span className="prefix-ksa" aria-hidden>966+</span>

              <input
                className="ksa-phone-input"
                type="tel"
                inputMode="tel"
                autoComplete="tel"
                placeholder="5xxxxxxxx"
                dir="ltr"
                value={phoneLocal}
                onChange={(e) => handleLoginPhoneChange(e.target.value)}
                required
                pattern="^5\d{8}$"
                title="أدخل رقم جوال سعودي صحيح يبدأ بـ 5 ويتكون من 9 أرقام"
              />
            </label>

            {/* PASSWORD with eye toggle */}
            <label className="field field--pw">
              <span className="icon" aria-hidden>
                <img src={passIcon} alt="" />
              </span>

              <div className="with-icon" style={{ display: "flex", alignItems: "center", width: "100%" }}>
                <input
                  type={showPw ? "text" : "password"}
                  autoComplete="current-password"
                  placeholder="كلمة السر"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  style={{ flex: 1 }}
                />
                <button
                  type="button"
                  className="eye-btn"
                  onClick={() => setShowPw((v) => !v)}
                  aria-label={showPw ? "إخفاء كلمة السر" : "إظهار كلمة السر"}
                  title={showPw ? "إخفاء" : "إظهار"}
                >
                  <img src={showPw ? eyeOffIcon : eyeIcon} alt="" />
                </button>
              </div>
            </label>

            {error && <p className="error-text">{error}</p>}

            <button className="ghostLink no-underline" type="button" onClick={openForgot}>
              نسيت كلمة السر؟
            </button>

            <button className="cta" type="submit" disabled={submitting}>
              {submitting ? "جاري الدخول..." : "متابعة"}
            </button>

            <div className="signup">
              <span>ما عندك حساب؟ </span>
              <button
                className="accentLink no-underline"
                type="button"
                onClick={() => setCurrentView && setCurrentView("register")}
              >
                إنشاء حساب
              </button>
            </div>
          </form>
        </section>
      </div>

      {/* Desktop footer stays; mobile footer is a bottom-sheet */}
      <div className="desktop-only">
        <Footer setCurrentView={setCurrentView} />
      </div>
      <div className="hero">
        <MobileFooterSheet mode="sticky" />
      </div>

      {/* === Forgot Password Modal === */}
      {isForgotOpen && (
        <div
          className="auth-modal__backdrop"
          role="dialog"
          aria-modal="true"
          onClick={() => setIsForgotOpen(false)}
        >
          <div
            className="auth-modal__window"
            dir="rtl"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="auth-modal__close"
              onClick={() => setIsForgotOpen(false)}
              aria-label="إغلاق"
            >
              ×
            </button>

            <h3 className="auth-modal__title">نسيت كلمة المرور</h3>
            <p className="auth-modal__hint">ادخل رقم جوالك لإرسال رمز التحقق (OTP)</p>

            {/* PHONE in modal with +966 prefix */}
            <label className="field field--phone" style={{ marginTop: 10 }}>
              <span className="icon" aria-hidden>
                <img src={phoneIcon} alt="" />
              </span>

              <span className="prefix-ksa" aria-hidden>966+</span>

              <input
                className="ksa-phone-input"
                type="tel"
                inputMode="tel"
                placeholder="5xxxxxxxx"
                dir="ltr"
                value={forgotPhoneLocal}
                onChange={(e) => handleForgotPhoneChange(e.target.value)}
                onKeyDown={(e) => (e.key === "Enter" ? sendOtp() : null)}
                autoFocus
                required
                pattern="^5\\d{8}$"
                title="أدخل رقم جوال سعودي صحيح يبدأ بـ 5 ويتكون من 9 أرقام"
              />
            </label>

            {forgotError && <p className="error-text" style={{ marginTop: 8 }}>{forgotError}</p>}

            <div className="auth-modal__actions">
              <button
                type="button"
                className="cta"
                onClick={sendOtp}
                disabled={sendingOtp}
              >
                {sendingOtp ? "جارٍ الإرسال..." : "تأكيد"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
